function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "50. Boat");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M47.84,33.45c-.44-.66,1-.49-22.84,0V31H43a1,1,0,0,0,1-1.13l-.64-4.7A32.32,32.32,0,0,0,24.4.08C24.13,0,24.72,0,16,0a1,1,0,0,0-1,1V6a1,1,0,0,0,1,1h6.81L8.16,29.45A1,1,0,0,0,9,31H23v2.52C-.87,34,.52,33.8.13,34.51s-.53.08,7,13c.44.76-1.44.5,33.86.5.9,0,.49.32,6.91-13.58A1,1,0,0,0,47.84,33.45ZM25,6.07a27.31,27.31,0,0,1,0,19.54ZM41.37,25.44,41.85,29H25.67a29.25,29.25,0,0,0,1-24.23l-.7-1.69A30.32,30.32,0,0,1,41.37,25.44ZM17,2h6V5H17Zm6,8.36V29H10.85ZM40.36,46H8.57L2.72,36,45.42,35Z"
});

var SvgBoat = function SvgBoat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50._Boat",
    "data-name": "50. Boat",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Boat.4f5c0197.svg";
export { ForwardRef as ReactComponent };